import Vue from 'vue'
import { PageHeader, Form, Input, Button, Checkbox, Row, Col, DatePicker, Modal, Table, Radio, Popover, Alert, message } from 'ant-design-vue'
import 'moment/locale/zh-cn'
import './css/index.less'

Vue.use(PageHeader)
Vue.use(Form)
Vue.use(Input)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(Row)
Vue.use(Col)
Vue.use(DatePicker)
Vue.use(Table)
Vue.use(Radio)
Vue.use(Popover)
Vue.use(Alert)
Vue.prototype.$info = Modal.info
Vue.prototype.$error = Modal.error
Vue.prototype.$success = Modal.success
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$message = message
